// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-bubble {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: linear-gradient(135deg, #3B82F6, #2563EB);
    color: white;
    border: none;
    cursor: grab;

    display: flex;
    align-items: center;
    justify-content: center;

    -webkit-user-select: none;

            user-select: none;

    box-shadow:
            0 10px 25px -5px rgba(0,0,0,0.1),
            0 10px 10px -5px rgba(0,0,0,0.04);

    transition:
            transform 0.2s ease,
            box-shadow 0.3s ease;
}

.chat-bubble:hover:not(.dragging) {
    transform: scale(1.1);
    box-shadow:
            0 20px 40px -12px rgba(0,0,0,0.25);
}

.chat-bubble:active:not(.dragging) {
    transform: scale(0.95);
}

.chat-bubble.dragging {
    cursor: grabbing;
    transition: none;
    transform: none;
}

.chat-bubble.active {
    animation: pulse-glow 2s infinite;
}

.icon-container {
    transition: transform 0.3s ease;
    pointer-events: none;
}

.icon-container.rotated {
    transform: rotate(180deg);
}

.icon {
    width: 28px;
    height: 28px;
    color: white;
    pointer-events: none;
}

@keyframes pulse-glow {
    0%, 100% {
        box-shadow: 0 0 20px rgba(59, 130, 246, 0.3);
    }

    50% {
        box-shadow: 0 0 30px rgba(59, 130, 246, 0.5);
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/ChatBubble.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qDAAqD;IACrD,YAAY;IACZ,YAAY;IACZ,YAAY;;IAEZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB,yBAAiB;;YAAjB,iBAAiB;;IAEjB;;6CAEyC;;IAEzC;;gCAE4B;AAChC;;AAEA;IACI,qBAAqB;IACrB;8CAC0C;AAC9C;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,+BAA+B;IAC/B,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI;QACI,4CAA4C;IAChD;;IAEA;QACI,4CAA4C;IAChD;AACJ","sourcesContent":[".chat-bubble {\r\n    width: 64px;\r\n    height: 64px;\r\n    border-radius: 50%;\r\n    background: linear-gradient(135deg, #3B82F6, #2563EB);\r\n    color: white;\r\n    border: none;\r\n    cursor: grab;\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n\r\n    user-select: none;\r\n\r\n    box-shadow:\r\n            0 10px 25px -5px rgba(0,0,0,0.1),\r\n            0 10px 10px -5px rgba(0,0,0,0.04);\r\n\r\n    transition:\r\n            transform 0.2s ease,\r\n            box-shadow 0.3s ease;\r\n}\r\n\r\n.chat-bubble:hover:not(.dragging) {\r\n    transform: scale(1.1);\r\n    box-shadow:\r\n            0 20px 40px -12px rgba(0,0,0,0.25);\r\n}\r\n\r\n.chat-bubble:active:not(.dragging) {\r\n    transform: scale(0.95);\r\n}\r\n\r\n.chat-bubble.dragging {\r\n    cursor: grabbing;\r\n    transition: none;\r\n    transform: none;\r\n}\r\n\r\n.chat-bubble.active {\r\n    animation: pulse-glow 2s infinite;\r\n}\r\n\r\n.icon-container {\r\n    transition: transform 0.3s ease;\r\n    pointer-events: none;\r\n}\r\n\r\n.icon-container.rotated {\r\n    transform: rotate(180deg);\r\n}\r\n\r\n.icon {\r\n    width: 28px;\r\n    height: 28px;\r\n    color: white;\r\n    pointer-events: none;\r\n}\r\n\r\n@keyframes pulse-glow {\r\n    0%, 100% {\r\n        box-shadow: 0 0 20px rgba(59, 130, 246, 0.3);\r\n    }\r\n\r\n    50% {\r\n        box-shadow: 0 0 30px rgba(59, 130, 246, 0.5);\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
